async function validateField(value, validators) {
    for (const validator of validators) {
        const validationResult = await validator(value);

        if (!validationResult.isValid) {
            return validationResult;
        }
    }

    return {
        isValid: true
    };
};

export {
    validateField
};
